import React, { useState } from 'react'
import { Button, Grid } from '@material-ui/core'
import { A, navigate, usePath } from 'hookrouter'
import { ILibraryFolder, ILibraryItem } from 'hooks/useLibrary'
import { useStyles } from './LibraryTemplate.styles'
import { Card } from 'components/ui/DataDisplay/Card'
import { LibraryModal } from 'components/ui/Business/LibraryModal'
import { Clickable } from 'components/ui/Behaviors/Clickable'
import { Loader } from 'components/ui/Behaviors/Loader'
import { TextService } from 'shared/services/TextService'
import { HeaderTemplate, IHeader } from './HeaderTemplate'
import { useLanguage } from 'store/locale/hooks/useLanguage'

export interface ILibrary {
  header: IHeader
  folder: ILibraryFolder
  t: (key: string) => string
  isLoading: boolean
}

export const LibraryTemplate = ({ header, folder, t, isLoading }: ILibrary) => {
  const { language } = useLanguage()
  const classes = useStyles()
  const { childFolders, items } = folder

  const subDirectory = (window.location.pathname.match(/\//g) || []).length

  const [openModal, setOpenModal] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  const currentPath = usePath()

  const handleClick = (index: number) => {
    setCurrentIndex(index)
    setOpenModal(!openModal)
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  const goToPreviousStep = () => {
    const pathname = window.location.pathname
    const locationIndex = window.location.pathname.lastIndexOf('/')
    const newPath = pathname.substring(0, locationIndex)
    navigate(`${window.location.origin + newPath}`)
  }

  return (
    <>
      <HeaderTemplate {...header} standFirst={header.standFirst} />

      {isLoading ? (
        <Loader />
      ) : (
        <Grid container spacing={2} className={classes.wrapper}>
          <Grid container className={classes.buttonWrapper}>
            {subDirectory > 3 && (
              <>
                <Button className={classes.button} disableRipple={true} onClick={goToPreviousStep}>
                  <img src="/assets/pictos/arrow-left.svg" alt="left arrow" className={classes.arrowContainer} />
                  {t('back')}
                </Button>

                {/* 
                --------------> A conserver 
                <Button className={classes.button} disableRipple={true}>
                  <Link route={`/${language}/media/mediatheque`}>
                    <img src="/assets/pictos/home.svg" alt="home" className={classes.homeContainer} />
                    <p className={classes.text}>{t('mediaHome')}</p>
                  </Link>
                </Button> 
                <-------------- A conserver 
                */}
              </>
            )}
          </Grid>
          {childFolders.map(({ thumbnail, url, title, subtitle }: ILibraryFolder, index: number) => (
            <Grid item xs={12} sm={6} lg={4} className={classes.box} key={index}>
              <A href={`${currentPath}/${TextService.routifyName(title[language])}`}>
                <Card
                  imageRatio={398 / 224}
                  imageUrl={thumbnail === '' ? url : thumbnail}
                  lightText={subtitle[language]}
                  title={title[language]}
                  titleMaxLength={70}
                  descriptionMaxLength={150}
                />
              </A>
            </Grid>
          ))}

          {items.map(({ thumbnail, url, title, backgroundPosition }: ILibraryItem, index: number) => (
            <Grid item xs={12} sm={6} lg={4} className={classes.box} key={index}>
              <Clickable onClick={() => handleClick(index)}>
                <Card
                  imageRatio={398 / 224}
                  imageSize={'crop'}
                  backgroundPosition={backgroundPosition}
                  imageUrl={thumbnail === '' ? url : thumbnail}
                  title={title[language]}
                  titleMaxLength={70}
                  descriptionMaxLength={150}
                />
              </Clickable>
            </Grid>
          ))}
        </Grid>
      )}

      <LibraryModal
        isOpen={openModal}
        onClose={handleClose}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        items={items}
        t={t}
      />
    </>
  )
}
